import React, { useEffect, useState, useContext } from 'react';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';

function FinalizeSessionModal({finalizeSessionResult}){

    const clickResult = (result) => {
        finalizeSessionResult(result);
    };

    return(
        <div className='modal-container' style={{height:"200px", maxWidth:"400px"}}>
            <button className='modal-close-button' onClick={() => clickResult(false)}><Cross2Icon width='30px' height='30px'/></button>
            <div className='modal-header'>Finalize session</div>
            <div className='modal-content'>
                <div style={{fontSize:'18px'}}>Do you want to finalize the session?</div>
            </div>
            <div className="modal-footer" >
                <button className="button" style={{width:'100px'}} onClick={() => clickResult(true)}>Yes</button>
            </div>
        </div>
            );
}

export default FinalizeSessionModal;